module.exports = __webpack_public_path__ + "static/media/logo_big.10f50c47.png";